import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { buscarTodosPorIdCategoria } from '../servicios/subcategoriaService'
import Select from '../ui/Select'

const IndicarCategorias = ({ onChange, esScrap, esMasiva }) => {
  const [combosCategoria, setCombosCategoria] = useState([])
  const [categoriasSeleccionadas, setCategoriasSeleccionadas] = useState([])
  const [firstSelectValue, setFirstSelectValue] = useState(0)
  const [categoriasIniciales, setCategoriasIniciales] = useState([])
  const [botonHabilitado, setBotonHabilitado] = useState(false)

  const obtenerCategorias = async () => {
    const { data } = await buscarTodosPorIdCategoria(0, esScrap)

    setCategoriasIniciales(data)
    setCombosCategoria([
      {
        pos: 0,
        idCategoria: 0,
        categorias: [{ idSubCategoria: 0, descripcion: 'Elegir Categoría' }, ...data]
      }
    ])
  }

  useEffect(() => {
    obtenerCategorias()
  }, [esScrap])

  const handleChange = async (event, pos) => {
    event.persist()
    const { value, options, selectedIndex } = event.target
    const idCategoria = value
    const selectedText = options[selectedIndex].text
    const { data: categorias } = await buscarTodosPorIdCategoria(idCategoria)

    // si cambia de categoría "padre" elimina combos hijos para forzar elija de nuevo
    let combosFiltrado = combosCategoria.slice(0, pos + 1)

    // ya que eligió subcategoría elimina la opción "Elegir Subcategoría"
    combosFiltrado = combosFiltrado.map((cmb) => {
      return {
        ...cmb,
        categorias: cmb.categorias.filter((cat) => cat.idSubCategoria !== 0)
      }
    })

    if (pos === 0) {
      setFirstSelectValue(idCategoria)
    }

    if (categorias.length > 0) {
      setCombosCategoria([
        ...combosFiltrado,
        {
          pos: combosFiltrado.length,
          idCategoria,
          categorias: [
            { idSubCategoria: 0, descripcion: 'Elegir Subcategoría' },
            ...categorias
          ]
        }
      ])
      setBotonHabilitado(false)
    } else {
      onChange({ currentTarget: event.target }, 'num')
      setCategoriasSeleccionadas((prev) => [...prev, { idCategoria, selectedText }])
      setBotonHabilitado(true)
    }
  }

  const handleSeleccionarSiguiente = () => {
    setCombosCategoria([
      {
        pos: 0,
        idCategoria: 0,
        categorias: [
          { idSubCategoria: 0, descripcion: 'Elegir Categoría' },
          ...categoriasIniciales
        ]
      }
    ])
    setFirstSelectValue(0)
    setBotonHabilitado(false)
  }

  return (
    <>
      <p className="descripcion-cuadro-publicacion">
        Seleccionar bien la categoría, hará qué más interesados puedan encontrar tu
        producto.
      </p>
      <div className="d-none d-md-block">
        {combosCategoria.map((cat, i) => (
          <Select
            key={cat.idCategoria}
            // importante, para que setee idCategoria de componente "Publicar.jsx" recién cuando seleccione la categoría del último combo de categorías
            name={
              i === combosCategoria.length - 1
                ? 'idCategoria'
                : `idcategoria${cat.idCategoria}`
            }
            value={i === 0 ? firstSelectValue : undefined}
            defaultValue={i === 0 ? undefined : cat.idCategoria}
            onChange={(e) => handleChange(e, cat.pos)}
            className="select-publicacion categorias-publicacion"
            datos={cat.categorias}
            optionMetaDatos={{ value: 'idSubCategoria', text: 'descripcion' }}
          />
        ))}
      </div>
      {esMasiva && (
        <>
          <div style={{ marginTop: '1rem' }}>
            <button
              type="button"
              className="btn btn-primary"
              disabled={!botonHabilitado}
              onClick={handleSeleccionarSiguiente}
            >
              Elegir siguiente categoría
            </button>
          </div>
          {categoriasSeleccionadas.length > 0 && (
            <div
              style={{
                marginTop: '1rem',
                display: 'flex',
                gap: '0.5rem',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <span style={{ fontWeight: 'bold' }}>Categorías seleccionadas:</span>
              {categoriasSeleccionadas.map(({ idCategoria, selectedText }) => (
                <div
                  key={idCategoria}
                  style={{
                    padding: '0.75rem 2.5rem 0.75rem 1rem',
                    background: '#f1f1f1',
                    borderRadius: '8px',
                    display: 'inline-block',
                    position: 'relative'
                  }}
                >
                  <span>
                    {idCategoria} - {selectedText}
                  </span>
                  <button
                    type="button"
                    aria-label="Quitar categoría"
                    onClick={() => {
                      const nuevasCategorias = categoriasSeleccionadas.filter(
                        (id) => id.idCategoria !== idCategoria
                      )
                      setCategoriasSeleccionadas(nuevasCategorias)
                    }}
                    style={{
                      position: 'absolute',
                      right: '0.5rem',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'transparent',
                      border: 'none',
                      fontSize: '1.2rem',
                      cursor: 'pointer'
                    }}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </>
  )
}

IndicarCategorias.propTypes = {
  onChange: PropTypes.func.isRequired,
  esScrap: PropTypes.bool,
  esMasiva: PropTypes.bool
}

export default IndicarCategorias
